import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static outlets = ['clients--global-uploader-modal']

  show() {
    this.clientsGlobalUploaderModalOutlet.show()
  }
}
